// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadFeaturedCategory,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

type HandlerType = Parameters<typeof LoadFeaturedCategory>[0];

export const LoadFeaturedProducts = (props: HandlerType) => {
    const {
        parameter: { carouselType },
    } = props;
    if (carouselType !== "featuredProducts" || (props.parameter as any).productIds.length === 0) {
        return;
    }
    props.getProductCollectionParameter = { names: (props.parameter as any).productIds };
};

export const LoadHeaderRecentlyPurchased = (props: HandlerType) => {
    const {
        parameter: { carouselType },
    } = props;
    if (carouselType !== "headerRecentlyPurchased") {
        return;
    }
    props.getProductCollectionParameter = { filter: "recentlyPurchased", pageSize: 4 };
};

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(chain, LoadFeaturedCategory, LoadFeaturedProducts);
addToChainAfter(chain, LoadFeaturedProducts, LoadHeaderRecentlyPurchased);
